import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import { Link, RouteChildrenProps } from "react-router-dom";
import "../../../assets/scss/components/login/loginScreen/loginHelp.scss";
import DeviceContext from "../../service/indentifyDevice";
import { urls } from "../loginConstants";
import LoginService from "./../../service/login/loginService";
import logo from "../../../assets/images/logo_white.jpg";

export interface ILoginHelpProps {}

const LoginHelp: React.FC<ILoginHelpProps & RouteChildrenProps> = (props) => {
	function onClose() {
		redirect(urls.login);
	}

	function redirect(url: string) {
		if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
			// If url is absolute
			window.location.href = url;
		} else {
			// if url is relative
			props.history.push(url);
		}
	}

	return (
		<LoginPopup
			leftHeaderContent={
				<Link to={urls.login} className="ed_button link action icon_button">
					<i className="arrow_left edel-icon-arrow-left vTextTop" />
					<span>Back</span>
				</Link>
			}
			centerHeaderContent={DeviceContext().isDesktop ? <img src={logo} alt="nuvama" className="nuvama_logo"/> : undefined}
			onClose={LoginService.hideCross ? undefined : onClose}
			className="login_help_ppup"
		>
			<section className="login_help_cont">
				<div className="login_help">
					<Link to="/login/forgot-loginid" className="help_links ib">
						<i className="edel-icon-forgot-login icon mg-r20" />
						<span>Forgot login ID</span>
						<i className="edel-icon-go" />
					</Link>
					<Link to="/login/forgot-password" className="help_links ib">
						<i className="edel-icon-password icon mg-r20" />
						<span>Forgot password</span>
						<i className="edel-icon-go" />
					</Link>
					<Link to="/login/unblock-account" className="help_links ib">
						<i className="edel-icon-unlock icon mg-r20" />
						<span>Unblock account</span>
						<i className="edel-icon-go" />
					</Link>
					<Link to="/login/forgot-yob" className="help_links ib">
						<i className="edel-icon-yob icon mg-r20" />
						<span>Get your YOB</span>
						<i className="edel-icon-go" />
					</Link>
				</div>
			</section>
		</LoginPopup>
	);
};

export default LoginHelp;
